export default "__VITE_ASSET__Ue1$tqtG__"